import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '360px',
    maxWidth: '90vw',
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.custom.background.area,
    padding: theme.spacing(6, 3, 3, 3),
    margin: 'auto',
    borderRadius: theme.shape.borderRadiusLarge,

    '& .logo': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing(4),
      },

      '&-img': {
        maxWidth: 180,
        maxHeight: theme.spacing(9),
        objectFit: 'contain',
        margin: `0 auto ${theme.spacing(2)}px`,
      },
    },

    '& .input': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',

        '&.email': {
          marginBottom: theme.spacing(3),
        },
        '&.password': {
          marginBottom: theme.spacing(1),
        },
      },

      '&': {
        display: 'flex',
      },
    },

    '& .forgot-password': {
      color: theme.palette.text.secondary,
      textAlign: 'right',
      marginBottom: theme.spacing(2),
    },

    '& .btn-login': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
      },

      '&': {
        marginBottom: theme.spacing(1),
      },
    },

    '& .keep-connected': {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightMedium,
    },

    '& .sign-up': {
      '&-container': {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(3),
      },

      '&': {
        textTransform: 'none',
        letterSpacing: 0,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
}));

export default styles;
